<template>
  <table class="print-table">
    <thead>
      <tr>
        <th width="24">序号</th>
        <th>商品名称</th>
        <th>规格(mm)</th>
        <th>单位</th>
        <th>数量</th>
        <th>商品单价(元)</th>
        <th>商品金额(元)</th>
        <th>加工金额(元)</th>
        <th>费用金额(元)</th>
        <th width="120">备注</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="(item, index) in selfData" :key="index">
        <td>{{ index + 1 }}</td>
        <td>{{ item.name }}</td>
        <td>{{ item.spec }}</td>
        <td>{{ item.unit }}</td>
        <td>{{ item.counts }}</td>
        <td>{{ item.goods_price }}</td>
        <td>{{ item.goods_amount }}</td>
        <td>{{ item.jia_gong }}</td>
        <td>{{ item.fei_yong }}</td>
        <td>{{ item.report_remark }}</td>
      </tr>
      <tr>
        <td>合计</td>
        <td></td>
        <td></td>
        <td></td>
        <td>{{ totalCounts }}</td>
        <td>{{ totalGoodsPrice }}</td>
        <td>{{ totalGoodsAmount }}</td>
        <td>{{ totalJiaGong }}</td>
        <td>{{ totalFeiYong }}</td>
        <td></td>
      </tr>
    </tbody>
  </table>
</template>

<script>
export default {
  props: {
    data: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      selfData: [],
      totalCounts: 0,
      totalGoodsPrice: 0,
      totalGoodsAmount: 0,
      totalJiaGong: 0,
      totalFeiYong: 0
    }
  },
  mounted() {
    this.selfData = this.$util.deepCopy(this.data)
    this.totalCounts = this.$util.listFieldTotal(this.selfData, 'counts')
    this.totalGoodsPrice = this.$util.listFieldTotal(this.selfData, 'goods_price')
    this.totalGoodsAmount = this.$util.listFieldTotal(this.selfData, 'goods_amount')
    this.totalJiaGong = this.$util.listFieldTotal(this.selfData, 'jia_gong')
    this.totalFeiYong = this.$util.listFieldTotal(this.selfData, 'fei_yong')
  }
}
</script>

<style lang="less" scoped>
.print-table {
  margin-top: 5px;
  width: 100%;
  border-collapse: collapse;
  border-left: 1px solid #000;
  border-top: 1px solid #000;
  text-align: center;
}
.print-table th,
.print-table td {
  border-right: 1px solid #000;
  border-bottom: 1px solid #000;
  padding: 2px;
  overflow-wrap: anywhere;
}
.print-table th {
  font-weight: normal;
  background: #e0e5eb;
}
</style>
